import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../services/api';

export interface Budget {
  id: string;
  monthly_limit?: number;
  per_purchase_limit?: number;
  quick_approve_threshold?: number;
  manual_checkout_threshold?: number;
  current_month_spent: number;
}

interface UpdateBudgetInput {
  monthly_limit?: number | null;
  per_purchase_limit?: number | null;
  quick_approve_threshold?: number | null;
  manual_checkout_threshold?: number | null;
}

export function useBudget() {
  return useQuery({
    queryKey: ['budget'],
    queryFn: async () => {
      const res = await api.get<{ success: boolean; data: Budget }>('/budget');
      return res.data.data;
    },
  });
}

export function useUpdateBudget() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (input: UpdateBudgetInput) => {
      const res = await api.put<{ success: boolean; data: Budget }>('/budget', input);
      return res.data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['budget'] });
    },
  });
}
